export const OTHER_REFERRAL_ID = 9;
